<template>
  <div v-if="publicModeEnabled">
    <router-btn
      :text="isPublic ? $t('servicesystem.common_objects.customer.deny_public_view') : $t('servicesystem.common_objects.customer.allow_public_view')"
      :icon="isPublic ? 'mdi-web-remove' : 'mdi-web'" :color="isPublic ? 'warning' : 'tertiary'" :disabled="false"
      :outlined="false" :textbtn="textbtn" :large="large" :small="small" :loading="loading" @Press="action()">
    </router-btn>
  </div>
</template>


<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";
import clientAPI from "@/api/ClientAPIMixin.js";

export default {
  name: "TogglePublicViewBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn },
  mixins: [clientAPI],

  data() {
    return {
      loading: true,
      isPublic: true,
    };
  },

  created() { },

  mounted() {
    this.getPublicState();
  },

  methods: {
    async getPublicState() {
      this.loading = true;
      this.isPublic = await clientAPI.methods.getCustomerPublicById(this.customerId).finally(() => {
        this.loading = false;
      });
    },

    async togglePublicState() {
      await clientAPI.methods.toggleCustomerPublicById(this.customerId)
        .then(result => {
          this.isPublic = result;
          //this.$router.push({ query: { timestamp: this.getNowTime(this.oldTimeFormat) } });
        }).finally(() => {
          this.loading = false;
        });
    },

    async action() {
      await this.togglePublicState();
    },
  },

  computed: {
    customerId() {
      return this.$route.params.customerId;
    },

    publicModeEnabled() {
      return this.$store.state.GlobalSettings.Features.PublicPortalEnabled;
    },
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>
